import { render, staticRenderFns } from "./Func16.vue?vue&type=template&id=f18e81c6"
import script from "./Func16.vue?vue&type=script&lang=js"
export * from "./Func16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports